import React, {useEffect, useState } from "react";
import
  PropTypes
from 'prop-types';
import * as Constants from '../../../components/common/Constants';
import * as OtpTagging from '../../../tagging/OtpFormTagging';
import * as ForgotPasswordTagging from '../../../tagging/ForgetPasswordFormTagging';
import { MainContainer, MobileViewLogo } from "../registration/RegistrationLayout.styled";
import businessLogo from '../../../images/plain-business-logo.svg';
import { PrimaryButton, RegularText, RegularUnderlinedText, SecondaryButton, XXLBoldText } from "../input/TextField.styles";
import { TextField } from "../input";
import ProfileService from "../../../services/ProfileService";
import Captcha from "../../../components/common/Captcha";
import { useSelector } from "react-redux";
import { OtpPopUp } from "../OtpPopUp/OtpPopUp";
import Loader from "../../../components/common/Loader";
import { ErrorPage } from "../errorPage/ErrorPage";


const ERROR_MESSAGE = {
    TECHNICAL_ERROR : 'We’re experiencing technical difficulties. Please try again later.'
};
export const ForgotPassword = (props) => {
  const [ forgotPasswordDetails, setForgotPasswordDetails ] = useState({});
  const { isCaptchaValidated } = useSelector((state) => ({ isCaptchaValidated: state.isCaptchaValidated }));
  const { captchaResponse } = useSelector((state) => ({ captchaResponse: state.captchaResponse }));
  const [ enableSubmit, setEnableSubmit ] = useState(false);
  const { msisdnNumber } = useSelector((state) => ({ state }));
  const [ viewPopup, setViewPopup ] = useState('none');
  const [ snackBarDisplay, setSnackBarDisplay ] = useState('none');
  const [ wrongOtpCount, setWrongOtpCount ] = useState(0);
  const [ isError, setIsError ] = useState();
  const [ errorMessage, setErrorMessage ] = useState([]);
  const [ otpResendMessage, setOtpResendMessage ] = useState({});
  const [ notificationAlertDisplay, setNotificationAlertDisplay ] = useState('none');
  const [ notificationAlertMessage, setNotificationAlertMessage ] = useState('');
  const [ showOtpPopUp, setShowOtpPopUP ] = useState(false);
  const [ otpCode, setOTPCode ] = useState("");
  const [ isPinReady, setIsPinReady ] = useState(false);
  const maximumCodeLength = 4;
  const [ otpSentTo, setOtpSentto ] = useState('');
  const [ showLoader, setShowLoader ] = useState(false);
  const [ disableField, setDisableField ] = useState(false);
  
  useEffect(() => {
    props.setDisplayView({...[], currentDisplay: Constants.FORGET_PASSWORD})
  }, []);

  useEffect(() => {
    if(notificationAlertDisplay === 'none') {
     setOTPCode('');
    }
   }, [notificationAlertDisplay])

  useEffect(() => {
    if (isCaptchaValidated  && !forgotPasswordDetails?.isError && forgotPasswordDetails?.value && forgotPasswordDetails?.value.length > 3) {
      props.setUsername(forgotPasswordDetails?.value)
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);

    }
  }, [isCaptchaValidated, forgotPasswordDetails]);

    
  useEffect(() => {
      if (viewPopup === 'flex') {
          setDisableField(true);
          setEnableSubmit(false)
          document.querySelector('html').classList.add('hide-scroller');

      } else {
          document.querySelector('html').classList.remove('hide-scroller');
          if (captchaResponse) {
              setEnableSubmit(true)
          }

          setDisableField(false)
      }
  }, [viewPopup]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

  const submitDisabled = () => {
    if(forgotPasswordDetails?.isError || !forgotPasswordDetails?.value) {

      return true;
    }

    return false;
  }

  const resendOtp = () => {
    setShowLoader(true);
    setWrongOtpCount(0);
    setOTPCode('');
    setOtpResendMessage({line1: "Your One-Time PIN has been resent.", line2: "Please check your inbox."});
    OtpTagging.resendOTP();
    setNotificationAlertDisplay('none');
    ProfileService.generateOTP(forgotPasswordDetails?.value)
        .then((response) => {
            setShowLoader(false);

            if (response.status === 400 || response.status === 404) {
                Constants.removeCookie(Constants.AUTH_TOKEN);
            }
            if (response.status === 200) {
              OtpTagging.generateOTP();
                if (response.data.result.message) {
                    setSnackBarDisplay('flex');
                    OtpTagging.OTPsuccefullyResent();
                    // this.props.setMsisdnNumber(response.data.result.message.substring((response.data.result.message.indexOf(":") + 1), response.data.result.message.length));
                    setInterval(()=>{
                        setSnackBarDisplay('none');
                    },9000)
                }
            }
        }).catch((error) => {
            setShowLoader(false);
            Constants.removeCookie(Constants.AUTH_TOKEN);
            props.setDisplay('flex');
            props.setNotificationText('We are unable to generate an OTP. Please try again later.');
            OtpTagging.generateOTPError('We are unable to generate an OTP.', 'Please try again later.');
          });
}
  
  const submit = (e) => {
    setNotificationAlertDisplay('none');
    e.preventDefault();
    setShowLoader(true);

    ProfileService.generateOtpForgotPassword(forgotPasswordDetails?.value, captchaResponse)
        .then((response) => {
            if (response.status === 200) {
                setShowLoader(false);
                if (response.data.result.message) {
                    const message = response.data.result.message;
                    setOtpSentto(message.substring(message.indexOf("+"), message.length).split('and'));
                    setViewPopup('flex');
                }
                ForgotPasswordTagging.forgetPasswordOtpPageLoad();
            }
        }).catch((error) => {
        if (error && error.response && error.response.data && error.response.data.messages && error.response.data.messages[0]) {
            setShowLoader(false);
            if (error.response.data.messages[0].message.includes('Your cellphone number is not linked to your profile')) {
                setShowLoader(false);
                setIsError(true);
                setErrorMessage({heading: 'Oops', messageLine1: "Unfortunately, you’ve entered the incorrect username.", messageLine2: "Please try again."});
                ForgotPasswordTagging.forgetPasswordErrorEvent("Unfortunately, you’ve entered the incorrect username.", "Please try again.");
            } else if (error.response?.data && error.response.data.messages[0]?.message  === "You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.") {
                setViewPopup('none');
                setIsError(true);
                setErrorMessage({heading: 'You’ve entered 3 invalid OTPs', messageLine1: 'For your security, you’ve been temporarily blocked from requesting new OTPs. Please try again in 24 hours.', messageLine2: ''});
                OtpTagging.lastInvalidOtpEntered("For your security, you’ve been temporarily blocked from requesting new OTPs. Please try again in 24 hours.");
            } else {
              scrollToTop();
              setShowLoader(false);
              props.setDisplay('flex');
              props.setNotificationText(error.response.data.messages[0].message);
              ForgotPasswordTagging.forgetPasswordErrorEvent(error.response.data.messages[0].message);
            }
        } else {
          scrollToTop();
          setShowLoader(false);
          props.setDisplay('flex');
          props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
          ForgotPasswordTagging.forgetPasswordErrorEvent(ERROR_MESSAGE.TECHNICAL_ERROR);
        }
    });
}

const validateOtp = (e) => {
  setShowLoader(true);

  OtpTagging.submitOTP();
  e.preventDefault();
  const authToken= Constants.getAuthToken(Constants.AUTH_TOKEN);

  ProfileService.validateOTP(otpCode, forgotPasswordDetails?.value)
  .then((response) => {
      if (response.status === 200) {
          setShowLoader(false);
          props.setDisplayView({...[], currentDisplay: Constants.FORGET_PASSWORD_CHANGE});
      }
  }).catch((err) => {
      setShowLoader(false);
      console.error(err);
        if (err && err.response && !err.response.status === 400) {
            Constants.removeCookie(Constants.AUTH_TOKEN);
        }
        
        if (err && err.response && err.response.data) {
          if (err && err.response && err.response.data && err.response.data.messages) {
              if (err.response.data.messages[0].message === "Your OTP has expired. Please request a new OTP.") {
                scrollToTop();
                props.setDisplay('flex');
                props.setNotificationText('Your OTP has expired. Please request a new OTP.');
              } else if (err.response.data.messages[0].message === "You have entered incorrect OTP. Please try again.") {
                  setViewPopup('flex')
                  if (wrongOtpCount === 0)
                  {
                    setNotificationAlertDisplay('flex');
                    setNotificationAlertMessage('Looks like you entered an invalid OTP. Please try again.');
                    OtpTagging.invalidOtpEntered('Looks like you entered an invalid OTP again', 'Please try again.');
                  }
                  if (wrongOtpCount === 1)
                  {
                    setNotificationAlertDisplay('flex');
                    setNotificationAlertMessage('Looks like you’ve entered an invalid OTP again. You have one attempt remaining. Please try again.');
                    OtpTagging.secondInvalidOtpEntered('Looks like you entered an invalid OTP again', 'You have one attempt remaining', 'Please try again.');
                  }
                  setWrongOtpCount(wrongOtpCount+1);
                } else if (err.response.data.messages[0].message  === "You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.") {
                  setViewPopup('none');
                  setIsError(true);
                  setErrorMessage({heading: 'You’ve entered 3 invalid OTPs', messageLine1: 'For your security, you’ve been temporarily blocked from requesting new OTPs. Please try again in 24 hours.', messageLine2: ''});
                  OtpTagging.lastInvalidOtpEntered("For your security, you’ve been temporarily blocked from requesting new OTPs. Please try again in 24 hours.");
                  Constants.removeCookie(Constants.AUTH_TOKEN);
                  setWrongOtpCount(0);
                } else {
                  setOTPCode('');
                  props.setDisplay('flex');
                  props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
                  OtpTagging.generateOTPError(ERROR_MESSAGE.TECHNICAL_ERROR);
                }
              }
            }
      }
      );
    }
  return (
    <>
      {
        isError ?
        <ErrorPage
          setIsError={setIsError}
          setErrorMessage={setErrorMessage}
          errorMessage={errorMessage}
        /> 
        : 
        <MainContainer>
          <img width={'100%'} height={props.imageHeight} src={businessLogo} alt="LOGO" />

          { showLoader && 
            <Loader/>
          }
          {  
            viewPopup === 'flex' &&
              <OtpPopUp
                code={otpCode}
                setCode={setOTPCode}
                maximumLength={maximumCodeLength}
                setIsPinReady={setIsPinReady}
                viewPopup={viewPopup}
                setViewPopup={setViewPopup}
                setOtpSentto={setOtpSentto}
                display={notificationAlertDisplay}
                setDisplay={setNotificationAlertDisplay}
                notificationText={notificationAlertMessage}
                setNotificationText={setNotificationAlertMessage}
                otpSentTo={otpSentTo}
                validateOtp={validateOtp}
                otpResendMessage={otpResendMessage}
                snackBarDisplay={snackBarDisplay}
                setSnackBarDisplay={setSnackBarDisplay}
                resendOtp={resendOtp}
                setShowLoader={setShowLoader}
                showLoader={showLoader}
              />
          }
          <XXLBoldText>Forgot password?</XXLBoldText>

          <TextField
                inputLabel={'Username'}
                placeholder={'Enter username'}
                onChange={(e) => {
                    setForgotPasswordDetails({id: e.target.id, isError: false, message: '', value: e.target.value});
                }}
                value={forgotPasswordDetails?.value}
                disableField={disableField}
                setDisableField={setDisableField}
              />
              <Captcha/>
              <div style={{
              'display': 'flex',
              'justifyContent': 'center',
              'alignItems': 'center',
              'gap': '16px',
              'alignSelf': 'stretch'}}>
              <SecondaryButton
                  disabled={disableField}
                  onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.LOGIN})}
                }>Go back</SecondaryButton>

              <PrimaryButton disabled={!enableSubmit} onClick={submit}>Next</PrimaryButton>
            </div>
            
            <RegularText>
              Don't have an account?&nbsp;
              <RegularUnderlinedText onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.REGISTER})}}>Register</RegularUnderlinedText>
            </RegularText>
        </MainContainer>
      }
    </>
  );

}